module.exports = __webpack_public_path__ + "static/chemiecluster-logo-2b23484454d8b9c53cbbd3f14e1c1ab8.webp";